;(function() {
"use strict";

(function(module) {
try {
  module = angular.module('app.templates');
} catch (e) {
  module = angular.module('app.templates', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/_layout/header/header.html',
    '<a href="" ui-sref="app.home">Home</a>');
}]);
})();
}());
